module.exports = __webpack_public_path__ + "static/media/enter_sound.5b4a34e9.mp3";